import { FC } from 'react'

// Components
import {
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  List,
  ListItem,
  ListItemText,
  Button,
  Box,
  Typography,
  IconButton,
  CircularProgress,
} from '@mui/material'
import { Add, Close } from '@mui/icons-material'
import { AssignCardModalProps } from './AssignCardModal.types'
import { LoadingButton } from '@mui/lab'

// Style
import './AssignCardModal.scss'

// Other
import { useAssignCardModalLogic } from './AssignCardModal.logic'

export const AssignCardModal: FC<AssignCardModalProps> = ({
  open,
  onClose,
  onCreateNew,
  data,
}) => {
  const {
    surgeonName,
    searchModalCards,
    filteredCards,
    handleAssign,
    isLoading,
    isAssigning,
    setSearchModalCards,
    assigningCardId,
  } = useAssignCardModalLogic({
    open,
    onClose,
    onCreateNew,
    data,
  })

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h6">
            Assign Preference Card to {surgeonName}
          </Typography>
          <IconButton onClick={onClose} size="small">
            <Close />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Box display="flex" gap={2} mb={2} mt={1}>
          <TextField
            fullWidth
            label="Search preference cards"
            value={searchModalCards}
            onChange={(e) => setSearchModalCards(e.target.value)}
            variant="outlined"
            size="small"
          />
          <Button
            variant="contained"
            size="small"
            startIcon={<Add />}
            onClick={onCreateNew}
            fullWidth
            sx={{ maxWidth: '150px' }}
          >
            Create New
          </Button>
        </Box>

        {isLoading && (
          <div className="pref-cards-loading-container">
            <CircularProgress />
          </div>
        )}
        <List>
          {filteredCards?.map((card) => (
            <ListItem
              key={card.id}
              divider
              secondaryAction={
                <LoadingButton
                  variant="outlined"
                  onClick={() => handleAssign(card.id)}
                  size="small"
                  loading={isAssigning && assigningCardId === card.id}
                >
                  Assign
                </LoadingButton>
              }
              sx={{ pr: '100px' }}
            >
              <ListItemText
                primary={
                  <Typography>{card.name || 'No Name Available'}</Typography>
                }
                secondary={
                  <Typography variant="body2" color="text.secondary">
                    {card.procedure_type}
                  </Typography>
                }
              />
            </ListItem>
          ))}
          {filteredCards?.length === 0 && !isLoading && (
            <ListItem>
              <ListItemText
                primary="No preference cards found"
                secondary="Try adjusting your search or create a new one"
              />
            </ListItem>
          )}
        </List>
      </DialogContent>
    </Dialog>
  )
}
